enum KioskOrderingMode {
  Full = 'full',
  ScannerOnly = 'scanner-only',
}

export { KioskOrderingMode };
